// extracted by mini-css-extract-plugin
export default {"LoginForm":"LoginDialog_LoginForm__jKw5h","PhoneInput":"LoginDialog_PhoneInput__8UMER"};